import { InfoMailtipAutomaticReplyMultiple } from './OofMailtip.locstring.json';
import { HideInfobarDetailsButton } from 'owa-locstrings/lib/strings/hideinfobardetailsbutton.locstring.json';
import { ShowInfobarDetailsButton } from 'owa-locstrings/lib/strings/showinfobardetailsbutton.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react';
/* tslint:disable:jsx-no-lambda WI:47750 */
import SingleRecipientAutomaticReplyDetails, {
    RecipientMailtipInfo,
} from './SingleRecipientAutomaticReplyDetails';
import * as React from 'react';
import { InfoBarMessagePart } from 'owa-info-bar-view';

import MultiRecipientMailtip from './MultiRecipientMailtip';
import MultiRecipientAutomaticReplyDetails from './MultiRecipientAutomaticReplyDetails';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import {
    createRemoveAllRecipientsLink,
    createRemoveRecipientLink,
} from '../utils/createRemoveRecipientLinks';
import { MailTipsCategory } from '../datapoints';

export interface OofMailtipProps {
    colorScheme?: ColorScheme;
    onRemove: (recipients: EmailAddressWrapper[]) => void;
    recipientsInfo: RecipientMailtipInfo[];
}

@observer
export default class OofMailtip extends React.Component<OofMailtipProps, any> {
    private createSingleRecipientOOFMailtip = () => {
        const recipientInfo: RecipientMailtipInfo = this.props.recipientsInfo[0];
        return (
            <SingleRecipientAutomaticReplyDetails
                recipientInfo={recipientInfo}
                colorScheme={this.props.colorScheme}
                removeRecipientActionElement={
                    <InfoBarMessagePart
                        colorScheme={this.props.colorScheme}
                        messagePart={createRemoveRecipientLink(
                            recipientInfo.recipient,
                            this.props.onRemove,
                            MailTipsCategory.OutOfOffice
                        )}
                    />
                }
            />
        );
    };

    private createMultiRecipientOOFMailtip = () => {
        const { recipientsInfo, onRemove, colorScheme } = this.props;
        return (
            <MultiRecipientMailtip
                colorScheme={colorScheme}
                messageInfoElement={
                    <InfoBarMessagePart
                        colorScheme={colorScheme}
                        messagePart={format(
                            loc(InfoMailtipAutomaticReplyMultiple),
                            recipientsInfo.length
                        )}
                    />
                }
                removeAllActionElement={
                    onRemove && (
                        <InfoBarMessagePart
                            colorScheme={colorScheme}
                            messagePart={createRemoveAllRecipientsLink(
                                recipientsInfo.map(recipientInfo => recipientInfo.recipient),
                                onRemove,
                                MailTipsCategory.OutOfOffice
                            )}
                        />
                    )
                }
                showHideDetails={{
                    showDetailsText: loc(ShowInfobarDetailsButton),
                    hideDetailsText: loc(HideInfobarDetailsButton),
                    detailsElement: null,
                }}
                detailsRenderer={() => <MultiRecipientAutomaticReplyDetails {...this.props} />}
                mailTipsCategory={MailTipsCategory.OutOfOffice}
                recipientCount={recipientsInfo.length}
            />
        );
    };

    render() {
        const { recipientsInfo } = this.props;

        if (recipientsInfo.length === 0) {
            return null;
        } else if (recipientsInfo.length === 1) {
            return this.createSingleRecipientOOFMailtip();
        }

        return this.createMultiRecipientOOFMailtip();
    }
}
